export default __webpack_public_path__ + "static/media/Q42022.fdc295d8.pdf";